import { optionActions } from 'core/Option';
import { parseBool } from 'shared/utils';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Container,
    Table
} from 'mol-ui';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const CampaignsConfiguration = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { dangerColor, successColor } = useTheme();

    const {
        campaignTypes,
        campaignTypesLoading
    } = useSelector('option');

    useEffect(() => {
        dispatch(optionActions.getCampaignTypes());
    }, []);

    const handleChange = (id, active) => {
        dispatch(optionActions.updateCampaignType({
            active,
            id
        }));
    };

    const actionController = [{
        display: ({ active }) => !active,
        icon: 'done',
        onClick: ({ id }) => handleChange(id, 1),
        title: t('Activar')
    }, {
        display: ({ active }) => !!active,
        icon: 'close',
        onClick: ({ id }) => handleChange(id, 0),
        title: t('Desactivar')
    }];

    const headers = [{
        flex: 3,
        key: 'label',
        label: t('Nombre')
    }, {
        accessor: active => parseBool(!!active),
        format: ({ active }) => ({
            center: true,
            color: !!active ? successColor : dangerColor
        }),
        key: 'active',
        label: t('Activo')
    }];

    return (
        <Container>
            <Table
                config={ headers }
                data={ campaignTypes }
                loading={ campaignTypesLoading }
                rowActions={ actionController }
            />
        </Container>
    );
};

export default CampaignsConfiguration;
